import { array, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';
import { Id as RequestTypeId } from '../../job/request-type';

export const RequestType = struct({
	equalsType: EqualsType,
	values: array(RequestTypeId),
});
